import http from "@/require"
import { ajaxGetCode, ajaxpostExportWithGet } from "@/require/index"
import axios from "axios";
// export function getContent() {
//     return http({
//         method: "get",
//         url: '/-16770/channel.xml',
//     })
// }

export const getContent = () => axios.get(
        `https://customized.drcnet.com.cn/config/${localStorage.getItem(`userId${localStorage.getItem("userId").split('/u/')[1]}`)}_Channel.xml?t=${new Date().getTime()}`
);
// 生成栏目配置
export const createColumnContent = () => axios.get(
    `https://suser.drcnet.com.cn/user/createPersionalChannel?userId=${localStorage.getItem(`userId${localStorage.getItem("userId").split('/u/')[1]}`)}`
);

// export function getContent() {
//     return http({
//         method: "get",
//         url: `/config/-16770_Channel.xml`,
//     })
// }

export function getNav(params) {
    return http({
        method: "get",
        url: '/reportapi/personalization/getUserWebChannel',
        params
    })
}

export function getDoc(params) {
    return http({
        method: "get",
        url: '/CommonController/common/getDocListByUid',
        params
    })
}

// 搜索 ： 获取检索范围  根据catalogId
export function getSearchRange(params) {
    return http({
        method: "get",
        url: '/reportapi/personalization/getUserCatalog',
        params
    })
}
// 获取文章
export function getDocList(params) {
    return http({
        method: "get",
        // url: '/reportapi/PdocApiController/api/document/docByWebChannel',
        url: '/reportapi/NewCultureIndustryController/cultureindustry/getDocListByUid',
        params
    })
}
// 获取用户订阅
export function getUserSubscribe(params) {
    return http({
        method: "get",
        url: `/reportapi/personalization/getWebChannelByUserID?t=${new Date().getTime()}`,
        params
    })
}

// 获取用户配置
export function getUserConfig() {
    return http({
        method: "get",
        url: `https://customized.drcnet.com.cn/config/${localStorage.getItem(`userId${localStorage.getItem("userId").split('/u/')[1]}`)}_config.json?t=${new Date().getTime()}`,
    })
}